export default class FullPageScroller {
  constructor(el, startPage = 1, totalPages = 100, options = {}) {
    this.el = el
    this.currentPage = startPage
    this.totalPages = totalPages
    this.options = {
      verticalScrollThreshold: 10,
      horizontalScrollThreshold: 20,
      verticalScrollDebounce: 1000,
      ...options
    }
    this._addListeners()
    this.isScrolling = false
  }
  scroll(delta) {
    if (delta < 0 && this.currentPage > 1)
      this.currentPage--
    if (delta > 0 && this.currentPage < this.totalPages) 
      this.currentPage++
    this.el.scroll({
      left: this.el.scrollLeft + (delta < 0 ? -1 : 1) * window.innerWidth,
      behavior: 'smooth'
    })
    document.dispatchEvent(new CustomEvent('slide-change'))
  }
  scrollTo(id, behavior = 'smooth') {
    this.currentPage = id
    this.el.scroll({
      left: (id - 1) * window.innerWidth,
      behavior
    })
    document.dispatchEvent(new CustomEvent('slide-change'))
  } 
  _addListeners() {
    document.addEventListener('touchstart', this._handleTouchstart.bind(this))
    document.addEventListener('touchend', this._handleTouchend.bind(this))
    //document.addEventListener('mousedown', this._handleMousedown.bind(this))
    //document.addEventListener('mouseup', this._handleMouseup.bind(this))
    document.addEventListener('keyup', this._handleKeyup.bind(this))
    document.addEventListener('wheel', this._handleWheel.bind(this))
    window.addEventListener('resize', this._handleResize.bind(this))
  }
  _remoteListeners() {
    document.removeEventListener('touchstart', this._handleTouchstart.bind(this))
    document.removeEventListener('touchend', this._handleTouchend.bind(this))
    document.removeEventListener('mousedown', this._handleMousedown.bind(this))
    document.removeEventListener('mouseup', this._handleMouseup.bind(this))
    document.removeEventListener('keyup', this._handleKeyup.bind(this))
    document.removeEventListener('wheel', this._handleWheel.bind(this))
    window.removeEventListener('resize', this._handleResize.bind(this))
  }
  _handleWheel(e) {
    if (!this._isScrollingAllowed(e) && !this.isScrolling && Math.abs(e.deltaX) >= this.options.verticalScrollThreshold) {
      this._debounce()
      this.scroll(e.deltaX)
    }   
  }
  _handleTouchstart(e) {
    this.startX = e.changedTouches[0].clientX
  }
  _handleTouchend(e) {
    if (!this._isScrollingAllowed(e)) {
      const deltaX = this.startX - e.changedTouches[0].clientX
      if (Math.abs(deltaX) >= this.options.horizontalScrollThreshold) 
        this.scroll(deltaX)
    }
  }
  _handleMousedown(e) {
    this.startX = e.clientX
  }
  _handleMouseup(e) {
    const deltaX = this.startX - e.clientX
    if (Math.abs(deltaX) >= this.options.horizontalScrollThreshold) 
      this.scroll(deltaX)
  }
  _handleKeyup(e) {
    if (e.keyCode === 37 || e.keyCode === 38)
      this.scroll(-1)
    if (e.keyCode === 39 || e.keyCode === 40)
      this.scroll(1)
  }
  _handleResize(e) {
    this.scrollTo(this.currentPage, 'auto')
  }
  _debounce() {
    this.isScrolling = true
    setTimeout(() => {
      this.isScrolling = false
    }, this.options.verticalScrollDebounce)
  }
  _isScrollingAllowed(e) {
    let allowed
    e.path && e.path.forEach(el => {
      if (el.classList && el.classList.contains('scrollable')) 
        allowed = true
    })
    return allowed
  }
}